export var masterFirebaseConfig = {
  apiKey: "AIzaSyCKsQbTWOl2cfVLqSH9p9WSh-SXBQHrr7o",
  authDomain: "nurture-b5dae.firebaseapp.com",
  databaseURL: "https://nurture-b5dae.firebaseio.com",
  projectId: "nurture-b5dae",
  storageBucket: "",
  messagingSenderId: "206669981511"
};



// WEBPACK FOOTER //
// /Users/Guest/Desktop/nurture/src/app/api-keys.ts